import React from 'react'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { ReactComponent as ContentDrop } from '../assets/svg/contentDrop.svg'

// Labels stay mounted in every sidebar state; `.sb-reveal` fades them with the panel (see
// styles/SideBar.css). A visibility:hidden label drops out of the accessible name, so the
// name lives on the focusable element itself via aria-label. `index` staggers the fade-in.
const SidebarItem = ({ item, index = 0, homeStatus, renderIcon, setHomeStatus, isOpen, onToggle }) => {
    const { t } = useTranslation()
    const selected = item.path?.some((p) => p.startsWith(homeStatus))
    const label = t(item.title)
    const labelStyle = { '--sb-i': index }

    if (item?.options && item?.options?.length > 0) {
        return (
            <div id={`sidebar-navigation-button-${item.name}`} data-title={label} className={`my-0 xl3:my-3 ${item.className}`}>
                <button type="button" onClick={() => onToggle(item)} aria-label={label} aria-expanded={isOpen} className="pointer cursor-pointer w-full text-start">
                    <div className={`h-[45px] 2xl:h-[52px] flex flex-row items-center relative sb-row transition-[height]`}>
                        <div className="sb-icon">{renderIcon(item?.name, selected ? '#FDDF6D' : '#F8F8FB')}</div>
                        {item?.icon}
                        <span className={`sb-reveal sb-label px-3 flex justify-between items-center w-full ellipsis ${selected ? ' text-highlightColor' : ''}`} style={labelStyle}>
                            {label} <ContentDrop className="sb-caret" aria-hidden="true" focusable="false" />
                        </span>
                    </div>
                </button>
                {/* Always mounted so opening can animate: the grid row grows from 0fr to 1fr
                    while the links fade in. Closed links are visibility:hidden, so they are
                    neither focusable nor announced. */}
                <div className="sb-reveal sb-label">
                    <div className={`sb-subnav-wrap ${isOpen ? 'is-open' : ''}`}>
                        <div className="sb-subnav-clip">
                            <div className="sb-subnav flex flex-col items-start">
                                {item?.options?.map((option, optionIndex) => (
                                    <Link to={option.path} className="my-2" onClick={() => setHomeStatus(option.path)} key={optionIndex}>
                                        <div
                                            id={`sidebar-navigation-nested-button-${option.title}`}
                                            className={`leading-[25px] ${option?.path === homeStatus ? 'text-highlightColor' : ''}`}
                                        >
                                            {t(option?.title)}
                                        </div>
                                    </Link>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    return (
        <div id={`sidebar-navigation-button-${item.name}`} data-title={label} className={`my-0 xl3:my-3 ${item.className}`}>
            <Link to={item?.path[0]} aria-label={label}>
                <div className={`h-[45px] 2xl:h-[52px] flex flex-row items-center relative sb-row w-full cursor-pointer transition-[height]`}>
                    <div className="sb-icon">{renderIcon(item?.name, selected ? '#FDDF6D' : '#F8F8FB')}</div>
                    {!!item?.icon && <div className="chat-badge-wrapper">{item?.icon}</div>}
                    <span className={`sb-reveal sb-label px-3 w-full ellipsis text-ellipsis ${selected ? ' text-highlightColor' : ''}`} style={labelStyle}>
                        {label}
                    </span>
                </div>
            </Link>
        </div>
    )
}

export default SidebarItem
